import React, { useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Button, Col, Spinner, Form, Container, Row, Image } from 'react-bootstrap'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../../../hooks/LoadingContext'
import UserCircle from '../../../../assets/UserCircle.svg'

import styles from './styles.module.css'
import { IMaskInput } from 'react-imask'
import { states } from '../../../../utils/states'

const EmpresaNova: React.FC = () => {
  const [name, setName] = useState<string>('')
  const [brandName, setBrandName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [state, setState] = useState<string>('')
  const [city, setCity] = useState<string>('')
  const [note, setNote] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [password_confirmation, setPassword_confirmation] = useState<string>('')

  const [profilePicture, setProfilePicture] = useState<File | null>()

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
      } else setProfilePicture(e.target.files[0])
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!isValidModel()) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }
    if (password !== password_confirmation) {
      toast.error('As senhas devem ser iguais!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      company_name: name,
      brand_name: brandName,
      phone,
      state,
      city,
      note,
      email,
      password,
      password_confirmation,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.post('/admin/companies', data, config)
      toast.info('Empresa cadastrada com sucesso!', {
        autoClose: 3000,
      })
      setIsLoading(false)
      navigate('/admin/empresas')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar a empresa! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return brandName && phone && city && state && email && password && password_confirmation
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Cadastrar empresa">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Nova empresa</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profilePicture ? URL.createObjectURL(profilePicture) : UserCircle}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={brandName}
                onChange={(event) => setBrandName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome fantasia
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome fantasia"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Telefone*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o telefone"
                as={IMaskInput}
                mask={[
                  { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                  { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                ]}
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Estado*
              </Form.Label>
              <Form.Select
                className={styles.input}
                value={state}
                onChange={(event) => setState(event.target.value)}
              >
                <option value="">Selecione o estado</option>
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Cidade*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cidade"
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nota
              </Form.Label>
              <Form.Control
                className={styles.input}
                as="textarea"
                placeholder="Digite aqui a nota"
                value={note}
                onChange={(event) => setNote(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>
          <Row
            style={{
              paddingBottom: 12,
              textAlign: 'left',
            }}
          >
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Repita a senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password_confirmation}
                onChange={(event) => setPassword_confirmation(event.target.value)}
              />
            </Col>
          </Row>
          <Col style={{ textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Cadastrar empresa'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
    </DashboardLayout>
  )
}

export default EmpresaNova
